import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { ProductService } from '../../../shared/services/product.service';

@Component({
  selector: 'app-product-nav',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './product-nav.component.html',
  styleUrl: './product-nav.component.scss'
})
export class ProductNavComponent {
  readonly path = inject(ActivatedRoute).snapshot.url;
  readonly productNav = inject(ProductService).getProductNav(this.path);
}
